import React from 'react';
import { Box } from '@mui/material';
import { FormLabel } from './formLabel';
import InputField from './inputField';

/**
 * FormItem Component (InputFieldComponent)
 * FormLabel과 InputField를 조합한 폼 아이템 컴포넌트
 * @param {Object} props
 * @param {string} props.title - 라벨 텍스트 (예: "기관이름 *" 또는 "기관이름")
 * @param {React.ReactNode} props.children - InputField 외의 커스텀 children
 * @param {Object} props.sx - Box 스타일
 */
const InputFieldComponent = ({
    title,
    children,
    sx = {}
}) => {
    // title에서 * 제거하고 required 여부 확인
    const hasRequired = title?.includes('*') || false;
    const labelText = title?.replace(/\s*\*$/, '').trim() || '';

    return (
        <Box sx={{
            height: '72px',
            ...sx
        }}>
            <FormLabel
                text={labelText}
                required={hasRequired}
                sx={{
                    mb: 1,
                    fontWeight: 500,
                    fontSize: '14px',
                    letterSpacing: '-0.42px',
                    textAlign: 'left'
                }}
            />
            {children}
        </Box>
    );
};

export default InputFieldComponent;

